import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { JwtAuthService } from '../../shared/services/auth/jwt-auth.service';

export interface WhatsappMediaPayload {
  number: string;
  caption?: string;
  media: string;
  fileName?: string;
  [key: string]: any;
}

@Injectable({ providedIn: 'root' })
export class WhatsappService {
  constructor(private http: HttpClient, private jwtAuthService: JwtAuthService) { }

  /**
   * Envia mensagem de texto/JSON para a Evolution API.
   * @param to destinatário (número ou id)
   * @param message conteúdo da mensagem
   * @param enviarAssunto opcional
   */
  sendText(instance: string, to: string, message: string, enviarAssunto = false): Observable<any> {
    const url = `${this.jwtAuthService.apiUrl}/evolution/w/message/sendText/${instance}`;
    const body = { to, message, enviarAssunto };
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(url, body, { headers }).pipe(catchError(this.handleError));
  }

  /**
   * Envia mídia (arquivos base64 ou url) para a Evolution API via JSON, conforme novo endpoint.
   * @param instance nome ou id da instância Evolution
   * @param payload objeto contendo os dados da mídia (number, caption, media, fileName, etc)
   */
  sendMedia(instance: string, payload: WhatsappMediaPayload): Observable<any> {
    const url = `${this.jwtAuthService.apiUrl}/evolution/message/sendMedia/${instance}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(url, payload, { headers }).pipe(catchError(this.handleError));
  }

  private createHeaders(apiKey?: string): HttpHeaders {
    let headers = new HttpHeaders();
    if (apiKey) {
      headers = headers.set('apikey', apiKey);
    }
    return headers;
  }

  private handleError(error: any): Observable<never> {
    let errorMessage = 'Erro desconhecido';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Erro: ${error.error.message}`;
    } else {
      if (error.status === 0) {
        errorMessage = 'Não foi possível conectar ao servidor';
      } else if (error.status === 401) {
        errorMessage = 'Não autorizado - verifique a API Key';
      } else if (error.status === 404) {
        errorMessage = 'Recurso não encontrado';
      } else if (error.status === 500) {
        errorMessage = 'Erro interno do servidor';
      } else if (error.error && error.error.message) {
        errorMessage = error.error.message;
      } else {
        errorMessage = `Erro ${error.status}: ${error.message}`;
      }
    }
    console.error('Erro WhatsappService:', error);
    return throwError(() => new Error(errorMessage));
  }
}
